import $ from 'jquery'
import ReactRailsUJS from 'react_ujs'

declare var gf: Object

/**
 * Set the loading state for a select element
 * @param {HTMLElement} selectEl - The select element
 * @param {string} label - The loading label
 */
function setLoadingState(selectEl, label = I18n.t('shared.loading')) {
  const props = JSON.parse(selectEl.dataset.reactProps)

  // Set options based on defaultValue
  if (props.defaultValue)
    props.options = Array.isArray(props.defaultValue) ? props.defaultValue : [props.defaultValue]
  else
    props.options = []

  // Create placeholder data
  const placeholderData = {label, value: '', disabled: true}

  // Always set fa-user icon for person selects
  const isPersonSelect = props.iconOnlySelection
    || (props.name && props.name.endsWith('[person_id]'))

  if (isPersonSelect)
    placeholderData.imageData = {fa_icon: 'fa-user'}

  props.placeholderData = placeholderData
  selectEl.dataset.reactProps = JSON.stringify(props)
  ReactRailsUJS.mountComponents(selectEl.parentElement)
}

/**
 * Render options for a select element
 * @param {HTMLElement} selectEl - The select element
 * @param {Array} options - The options to render
 * @param {string} placeholder - The placeholder text
 */
function renderOptions(selectEl, options, placeholder, eventType) {
  const props = JSON.parse(selectEl.dataset.reactProps)
  props.options = options
  if (eventType === 'role-changed' && (!props.defaultValue || !options.includes(props.defaultValue)))
    props.defaultValue = options.length === 1 ? [options[0]] : null

  // eslint-disable-next-line no-debugger

  // Create placeholder data with appropriate image data
  const imageData = {fa_icon: 'fa-user'}

  props.placeholderData = {
    label: placeholder,
    disabled: true,
    imageData,
  }
  ReactRailsUJS.unmountComponents(selectEl.parentElement)

  selectEl.dataset.reactProps = JSON.stringify(props)
  ReactRailsUJS.mountComponents(selectEl.parentElement)
}

/**
 * Gets the role context from data-role-context attribute
 * @param {Object} _ - Unused parameter, kept for API compatibility
 * @returns {string} - The role context identifier
 */
// eslint-disable-next-line no-unused-vars
function getRoleContext(_ = {}, form = null) {
  // Require form and data-role-context
  if (!form) {
    // Silent fail in production, default to DEFAULT
    return 'DEFAULT'
  }

  const $form = $(form)
  const roleContextEl = $form.find('[data-role-context]')[0]

  if (!roleContextEl || !roleContextEl.dataset.roleContext) {
    // Silent fail in production, default to DEFAULT
    return 'DEFAULT'
  }

  return roleContextEl.dataset.roleContext
}

async function loadPeople(event) {
  const $form = $(event.target).closest('form')
  const {
    roleIdParentRoleId,
    organizationId,
  } = event.originalEvent.detail
  const url = `/organizations/${organizationId}/dropdown_options/people?role_id_parent_role_id=${roleIdParentRoleId}`

  const personSelect = $form.find('[name$="[person_id]"]').closest('[data-react-class]')[0]
  if (!personSelect)
    return

  setLoadingState(personSelect, I18n.t('shared.loading'))

  if (!gf.asyncLoadPeoplePromises)
    gf.asyncLoadPeoplePromises = {}

  let promise = gf.asyncLoadPeoplePromises[url]

  if (!promise) {
    gf.asyncLoadPeoplePromises[url] = fetch(url, {credentials: 'same-origin'})
    gf.asyncLoadPeoplePromises[url].then(() => { gf.asyncLoadPeoplePromises[url] = null })
    promise = gf.asyncLoadPeoplePromises[url]
  }

  promise.then(async (response) => {
    if (!response.ok)
      throw new Error(I18n.t('shared.dropdown.error_loading_people'))
    const data = await response.clone().json()
    renderOptions(personSelect, data, I18n.t('shared.select_dot_dot_dot'), event.type)
    return response
  })
}

export function setupAsyncRolePersonDropdown() {
  $('body').on('role-changed', '.js-slick-role-select', (event) => {
    loadPeople(event)
  })
  $('body').on('role-init', '.js-slick-role-select', (event) => {
    // This is a workaround for the fact that the role-changed event is not fired on initial load
    setTimeout(() => loadPeople(event), 100)
  })
}

export default {
  setupAsyncRolePersonDropdown,
}
